import { useEffect, useState } from 'react';
import { useStore } from '@hmpu/powerups.store';
import { useTranslate } from '@hmpu/powerups.intl.legacy.hooks.use-translate';
import { useTranslation } from '@hmpu/powerups.intl.hooks.use-translation';
import { useVieConfig } from '@hmpu/powerups.vie.hooks.use-vie-config';
import { useSkipChapter } from '@hmpu/powerups.vie.hooks.use-skip-chapter';
import { globalizedMedia } from '@hmpu/powerups.intl.hooks.use-localized-media';
import useResetFocus from '../../hooks/useResetFocus';
import { CTAButton } from '@hmpu/powerups.ui.buttons.cta-button';

import './Splash.css';

export const Splash = () => {
  const translate = useTranslate();
  const parentNode = 'SPLASH';
  const { __t } = useTranslation(parentNode);
  const skipChapter = useSkipChapter();
  const logoAlt = __t('logoImageAlt');
  const translatedConfig = __t('vieConfig');
  const { vieConfigRef, updateVieConfig } = useVieConfig();
  const logoImg = globalizedMedia(translate('logoImg', 'DISCLAIMER'), 'img');
  const { goToNextPage } = useVieConfig();
  const currentCueMetadata = useStore((state) => state.currentCueMetadata);

  const pageTitle = translate('pageTitle', parentNode);
  const setPageTitle = useStore((state) => state.setPageTitle);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const inPortrait = useStore((state) => state.inPortrait);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  useResetFocus([showSettingsPanel, inPortrait, isPauseEnabled]);
  const [showSplashContent, setShowSplashContent] = useState(false);
  const playbutton = __t('playButton', 'SPLASH'); 

  useEffect(() => {
    setPageTitle(pageTitle);
  }, [showSettingsPanel, inPortrait, isPauseEnabled]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     document.querySelector("#SettingsPanel-Toggler")?.focus();
  //   }, 50)
  // }, [])

  useEffect(() => {
    const buttons = document.querySelectorAll('.cta-btn');
    buttons.forEach(button => {
      const span = button.querySelector('span');
      if (span) {
        span.setAttribute('data-text', span.textContent || '');
      }
    });
  }, [isPauseEnabled, currentCueMetadata?.id, showSplashContent]);

  useEffect(() => {
    console.log("CURRENTCUE ---------------------------- : " + currentCueMetadata?.id)
    if(currentCueMetadata?.id === "CHAPTER_HOLD") {
      setShowSplashContent(true);
      // document.getElementById("SettingsPanel-Toggler")?.focus();
    }
  }, [currentCueMetadata])

  useEffect(() => {
    if(currentCueMetadata?.id === "CHAPTER_HOLD") {
          document.getElementById("SettingsPanel-Toggler")?.focus();
    }
  }, [currentCueMetadata?.id])

  const templates = {
    'BP - Intro - 1 button': ({ onButtonClick, buttons }) => (
      <SplashButtonTemplates
        onButtonClick={onButtonClick}
        buttons={buttons}
        logoImg={logoImg}
        logoAlt={logoAlt}
      />
    ),
  };
  const SplashButtonTemplates = ({ onButtonClick, buttons }) => {
    const updatedButtons = [...buttons]; 
  
    if (updatedButtons.length > 0) {
      updatedButtons[0] = {
        ...updatedButtons[0],
        label: playbutton.label,
        ariaLabel: playbutton.ariaLabel,
      };
    }
  
    return (
      <></>
    );
  };

  useEffect(() => {
    updateVieConfig({
      ...translatedConfig,
      skipChapter: skipChapter,
      templates: templates,
    });
  }, []);

  useEffect(() => {
    if (skipChapter !== vieConfigRef.current.skipChapter) {
      updateVieConfig({ skipChapter });
    }
  }, [skipChapter, updateVieConfig, vieConfigRef]);

  return (
    <>
      {
        (showSplashContent) && (
          <section className='splash-page'>
            {/* <div className="splash-copy">
              <img src={logoImg} alt={logoAlt} className="splash-logo" />
            </div> */}
            <CTAButton
              primary
              className='splash-cta'
              onClick={(evt) => {
                document
                  .querySelectorAll('video')
                  .forEach((player) => player.play());
                goToNextPage(evt);
              }}
              intlKey={'playButton'}
              parentNode={parentNode}
            />
          </section>
        )
      }
    </>
  );
}

export default Splash;
